import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-more-actions-button',
  templateUrl: './more-actions-button.component.html',
  styleUrls: ['./more-actions-button.component.scss'],
})
export class MoreActionsButtonComponent {
  /** Container for dropdown (e.g. 'body' for modals/tables to avoid clipping) */
  @Input() container: 'body' | null = 'body';

  /** Tooltip text */
  @Input() tooltipText: string = 'Ações';
}
